/* 🤖 this file was generated by svg-to-ts */
export const mgcIconFlag3CuteFi: {
  name: 'flag-3-cute-fi';
  data: string;
} = {
  name: 'flag-3-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M6.2 2.342a3.254 3.254 0 0 0-.6.223c-.687.338-1.199 1.022-1.393 1.86-.181.781-.18.692-.195 8.89-.017 8.789-.042 8.057.286 8.385.48.48 1.292.352 1.588-.25.094-.19.094-.191.114-2.229l.02-2.038.765-.23c2.833-.85 5.627-1.922 8.555-3.282 2.459-1.142 3.325-1.642 3.961-2.285.58-.587.818-1.136.818-1.886 0-1.209-.671-2.049-2.399-3.003-2.171-1.199-7.385-3.388-9.48-3.981-.819-.231-1.502-.289-2.04-.174"/></svg>`
};
